export interface ITranslations {
    [key: string]: string
}

export const strings: { [key: number]: ITranslations } = {
    1033: {
        loading: `Loading...`,
        age: `Age`,
        comingBackOnline: `SHOULD NOT SEE THIS Coming back online...`,
        keepLocal: `SHOULD NOT SEE THIS Keep local copy`,
        keepServer: `SHOULD NOT SEE THIS Keep server copy`,
        desync: `SHOULD NOT SEE THIS Server/Local Desync`,
        viewingGuest: `SHOULD NOT SEE THIS Viewing guest plan`,
        back: `SHOULD NOT SEE THIS Back`,
        continue: `SHOULD NOT SEE THIS Continue`,
        xOfy: `SHOULD NOT SEE THIS {{x}} of {{y}}`,
        remaining: `SHOULD NOT SEE THIS Remaining`,
        saved: `SHOULD NOT SEE THIS Saved`,
        saving: `SHOULD NOT SEE THIS Saving...`,
        tutorial: `SHOULD NOT SEE THIS Tutorial`,
        assignFamily: `SHOULD NOT SEE THIS My Family`,
        priorities: `SHOULD NOT SEE THIS Priorities`,
        myFamily: `SHOULD NOT SEE THIS My Family`,
        home: `SHOULD NOT SEE THIS Home`,
        familyMediaPlan: `SHOULD NOT SEE THIS Family Media Plan`,
        enterFamilyName: `SHOULD NOT SEE THIS Enter your family name`,
        addAnotherFamilyMember: `SHOULD NOT SEE THIS Add Another Family Member`,
        addMembersFromAAPAccount: `SHOULD NOT SEE THIS Add family members from my AAP Account`,
        familyMembersName: `SHOULD NOT SEE THIS Family Member's Name`,
        selectYourAvatar: `SHOULD NOT SEE THIS Select Your Avatar`,
        selectAvatarBlurb: `SHOULD NOT SEE THIS Personalize your character to make your plan unique to your unique needs.`,
        addPageAsPriority: `SHOULD NOT SEE THIS Add page as priority`,
        pageNotPriorityBlurb: `SHOULD NOT SEE THIS This page is not a priority and will not show up in your final printout.`,
        selectAll: `SHOULD NOT SEE THIS Select All`,
        unselectAll: `SHOULD NOT SEE THIS Unselect All`,
        reasonsTips: `SHOULD NOT SEE THIS Reason / Tips`,
        reset: `SHOULD NOT SEE THIS Reset`,
        resetToAAPRecs: `SHOULD NOT SEE THIS Reset to AAP Recommendations`,
        close: `SHOULD NOT SEE THIS Close`,
        addAnother: `SHOULD NOT SEE THIS Add Another`,
        remove: `SHOULD NOT SEE THIS Remove`,
        review: `SHOULD NOT SEE THIS Review`,
        userMediaPlanTitle: `SHOULD NOT SEE THIS The {{FAMILYNAME}} Family Media Plan`,
        printButton: `SHOULD NOT SEE THIS Print Media Summary for`,
        printDescription: `SHOULD NOT SEE THIS Print description here...`,
        emailMediaPlanTo: `SHOULD NOT SEE THIS Email Media Plan To:`,
        smsMessageBody: `SHOULD NOT SEE THIS Check out my media plan I created:`,
        send: `SHOULD NOT SEE THIS Send`,
        sending: `SHOULD NOT SEE THIS Sending...`,
        sendAsTextButton: `SHOULD NOT SEE THIS Send media plan as a text message instead`,
        enterValidEmail: `SHOULD NOT SEE THIS Please enter a valid email (name@domain.com)`,
        errorSendingEmail: `SHOULD NOT SEE THIS There was an error sending the email`,
        emailSuccess: `SHOULD NOT SEE THIS Email sent!`,
        loginOrRegisterToSend: `SHOULD NOT SEE THIS Log in or register to email or text your media plan`,
        connectToInternetToSend: `SHOULD NOT SEE THIS Connect to the internet to email or text your media plan`,
        '0-24 months': `SHOULD NOT SEE THIS 0-24 months`,
        '2-5 years': `SHOULD NOT SEE THIS 2-5 years`,
        '6-12 years': `SHOULD NOT SEE THIS 6-12 years`,
        '13-18 years': `SHOULD NOT SEE THIS 13-18 years`,
        'Adult': `SHOULD NOT SEE THIS Adult`,
    },    
    3082: {
        loading: `Cargando...`,
        age: `Años`,
        comingBackOnline: `SHOULD NOT SEE THIS Reconectando...`,
        keepLocal: `SHOULD NOT SEE THIS Conservar copia local`,
        keepServer: `SHOULD NOT SEE THIS Conservar copia del servidor`,
        desync: `SHOULD NOT SEE THIS Servidor/Local no coinciden`,
        viewingGuest: `SHOULD NOT SEE THIS Ver plan de invitado`,
        back: `SHOULD NOT SEE THIS Volver`,
        continue: `SHOULD NOT SEE THIS Continuar`,
        xOfy: `SHOULD NOT SEE THIS {{x}} de {{y}}`,
        remaining: `SHOULD NOT SEE THIS Restantes`,
        saved: `SHOULD NOT SEE THIS Guardado`,
        saving: `SHOULD NOT SEE THIS Guardando...`,
        tutorial: `SHOULD NOT SEE THIS Tutorial`,
        assignFamily: `SHOULD NOT SEE THIS Mi familia`,
        priorities: `SHOULD NOT SEE THIS Prioridades`,
        myFamily: `SHOULD NOT SEE THIS Mi familia`,
        home: `SHOULD NOT SEE THIS Inicio`,
        familyMediaPlan: `SHOULD NOT SEE THIS Plan familiar de uso de pantallas`,
        enterFamilyName: `SHOULD NOT SEE THIS Ingrese el apellido familiar`,
        addAnotherFamilyMember: `SHOULD NOT SEE THIS Agregue a otro miembro de la familia`,
        addMembersFromAAPAccount: `SHOULD NOT SEE THIS Agregue miembros de la familia desde su cuenta de AAP`,
        familyMembersName: `SHOULD NOT SEE THIS Nombre del miembro de la familia`,
        selectYourAvatar: `SHOULD NOT SEE THIS Seleccione su avatar`,
        selectAvatarBlurb: `SHOULD NOT SEE THIS Personalice su personaje para hacer un plan que se adapte a sus necesidades`,
        addPageAsPriority: `SHOULD NOT SEE THIS Agregar página como prioridad`,
        pageNotPriorityBlurb: `SHOULD NOT SEE THIS Esta página no es prioridad y no se mostrará en la impresión final`,
        selectAll: `SHOULD NOT SEE THIS Seleccionar todos`,
        unselectAll: `SHOULD NOT SEE THIS Deseleccionar todos`,
        reasonsTips: `SHOULD NOT SEE THIS Razón / Consejos`,
        reset: `SHOULD NOT SEE THIS Reiniciar`,
        resetToAAPRecs: `SHOULD NOT SEE THIS Restablecer las recomendaciones de la AAP`,
        close: `SHOULD NOT SEE THIS Cerrar`,
        addAnother: `SHOULD NOT SEE THIS Agregar otro`,
        remove: `SHOULD NOT SEE THIS Eliminar`,
        review: `SHOULD NOT SEE THIS Revisar`,
        userMediaPlanTitle: `SHOULD NOT SEE THIS Plan familiar de uso de pantallas de los {{FAMILYNAME}}`,
        printButton: `SHOULD NOT SEE THIS Imprimir el resumen del plan para`,
        printDescription: `SHOULD NOT SEE THIS Imprimir la descripción aquí...`,
        emailMediaPlanTo: `SHOULD NOT SEE THIS Enviar el plan de uso de pantallas a:`,
        smsMessageBody: `SHOULD NOT SEE THIS Revisar el plan de uso de pantallas que he creado:`,
        send: `SHOULD NOT SEE THIS Enviar`,
        sending: `SHOULD NOT SEE THIS Enviando...`,
        sendAsTextButton: `SHOULD NOT SEE THIS Enviar plan de uso de pantallas como un mensaje de texto`,
        enterValidEmail: `SHOULD NOT SEE THIS Por favor ingrese una dirección de correo electrónico válida (nombre@dominio.com)`,
        errorSendingEmail: `SHOULD NOT SEE THIS Se produjo un error al enviar el correo electrónico`,
        emailSuccess: `SHOULD NOT SEE THIS ¡Correo electrónico enviado!`,
        loginOrRegisterToSend: `SHOULD NOT SEE THIS Ingrese o regístrese para enviar su plan de uso de pantallas por correo electrónico o mensaje de texto`,
        connectToInternetToSend: `SHOULD NOT SEE THIS Conéctese a la Internet para enviar su plan de uso de pantallas por correo electrónico o mensaje de texto`,
        '0-24 months': `SHOULD NOT SEE THIS 0-24 meses`,
        '2-5 years': `SHOULD NOT SEE THIS 2-5 años`,
        '6-12 years': `SHOULD NOT SEE THIS 6-12 años`,
        '13-18 years': `SHOULD NOT SEE THIS 13-18 años`,
        'Adult': `SHOULD NOT SEE THIS Adulto`,
    }
}